import React from 'react';
import { Typography, Box } from '@mui/material';
import { useClientStore } from '../../stores/clientStore';
import ClientDetails from '../components/ClientDetails';

const DashboardPage: React.FC = () => {
  
  const { client, clientId } = useClientStore();
  return (
    <Box sx={{ p: 3 }}>
      {
        !clientId || !client?._id || client?._id == ''
          ? <Typography variant="body1">
              Select a Client to view details.
            </Typography>
          : <ClientDetails />
      }
    </Box>
  );
};

export default DashboardPage;